/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateStockItemTransactionInput } from '../models/CreateStockItemTransactionInput';
import type { PagedStockItemTransactionSchema } from '../models/PagedStockItemTransactionSchema';
import type { StockItemTransactionListExportSchema } from '../models/StockItemTransactionListExportSchema';
import type { StockItemTransactionSchema } from '../models/StockItemTransactionSchema';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TransactionsApi {
    /**
     * Get Transaction List
     * Get list of stock item transactions
     * @returns PagedStockItemTransactionSchema OK
     * @throws ApiError
     */
    public static warehouseGetTransactionListGet({
        dateFrom,
        dateTo,
        operation,
        supplierId,
        search,
        limit = 100,
        offset,
    }: {
        dateFrom?: (string | null),
        dateTo?: (string | null),
        operation?: (string | null),
        supplierId?: (string | null),
        search?: (string | null),
        limit?: number,
        offset?: number,
    }): CancelablePromise<PagedStockItemTransactionSchema> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/transactions/',
            query: {
                'date_from': dateFrom,
                'date_to': dateTo,
                'operation': operation,
                'supplier_id': supplierId,
                'search': search,
                'limit': limit,
                'offset': offset,
            },
        });
    }
    /**
     * Create Transaction Item
     * Create transaction. Required Permission: warehouse_transactions_create
     * @returns StockItemTransactionSchema Created
     * @throws ApiError
     */
    public static warehouseCreateTransactionItemPost({
        requestBody,
    }: {
        requestBody: CreateStockItemTransactionInput,
    }): CancelablePromise<StockItemTransactionSchema> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/transactions/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Generate Export
     * Generate export of stock item transactions
     * @returns any Accepted
     * @throws ApiError
     */
    public static warehouseGenerateExportPost({
        requestBody,
    }: {
        requestBody: StockItemTransactionListExportSchema,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/transactions/export',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
